import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  SubContainerType,
  CreateSubContainerTypeRequest,
  UpdateSubContainerTypeRequest,
  SubContainerTypesListParams
} from '../sub-container-types.types';

const { SUB_CONTAINER_TYPES } = API_ENDPOINTS;

export const subContainerTypesApi = {
  getAll: (params?: SubContainerTypesListParams) =>
    apiClient.getPaginated<SubContainerType>(SUB_CONTAINER_TYPES.LIST, params),

  getById: (id: number) =>
    apiClient.get<SubContainerType>(SUB_CONTAINER_TYPES.GET(id)),

  create: (data: CreateSubContainerTypeRequest) =>
    apiClient.post<SubContainerType>(SUB_CONTAINER_TYPES.CREATE, data),

  update: (id: number, data: UpdateSubContainerTypeRequest) =>
    apiClient.put<SubContainerType>(SUB_CONTAINER_TYPES.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(SUB_CONTAINER_TYPES.DELETE(id)),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<SubContainerTypesListParams> }
  ) => apiClient.post(SUB_CONTAINER_TYPES.BULK_DELETE, params)
};
